import deepmerge from "deepmerge";
import { codigoPaquete, codigosTarjetas, nombresTarjetas } from "./paquetes";

const campania = process.env.VUE_APP_CAMP || "ofertaDigital";
const infoCampania = require(`@/config/brands/${campania}.js`).infoCampania;
const nombresTarjetasCampania =
  require(`@/config/brands/${campania}.js`).nombresTarjetas;

/**
 * Parsear respuesta de la API a objeto JSON
 * para mostrar info de paquetes.
 * @param {Object} paquetes
 */
export const paquetesBeneficios = paquetes => {
  //Return descripción de tarjetas de credito
  const descripcionTarjetasIncluidas = tarjetas => {
    let descripcionTarjeta = "";
    if (paquetes.tipoPaquete !== codigoPaquete.TARJETA_SUELTA) {
      for (let i = 0; i < tarjetas.length; i++) {
        //  let str = tarjetas[i].descripcion.toLowerCase()
        //  let nombreTarjeta = formatDescripcion(str)
        if (i == 0 && tarjetas.length > 1) {
          descripcionTarjeta += `${descripCodeTarjeta(
            tarjetas[i].tipoTarjeta
          )} y `;
        } else {
          descripcionTarjeta += `${descripCodeTarjeta(
            tarjetas[i].tipoTarjeta
          )}`;
        }
      }
      return descripcionTarjeta;
    } else {
      for (let tarjeta of tarjetas) {
        descripcionTarjeta += `${descripCodeTarjeta(tarjeta.tipoTarjeta)}`;
      }
      return descripcionTarjeta;
    }
  };

  //Return descripcion tarjeta suelta mediante código de tarjeta
  const descripCodeTarjeta = tipoTarjeta => {
    let descripcionTipoTarjeta = "";
    switch (tipoTarjeta) {
      case codigosTarjetas.VISA_INTERNACIONAL:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["VISA_INTERNACIONAL"];
        break;
      case codigosTarjetas.VISA_GOLD:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["VISA_GOLD"];
        break;
      case codigosTarjetas.VISA_PLATINUM:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["VISA_PLATINUM"];
        break;
      case codigosTarjetas.VISA_SIGNATURE:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["VISA_SIGNATURE"];
        break;
      case codigosTarjetas.MASTERCARD_GOLD:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["MASTERCARD_GOLD"];
        break;
      case codigosTarjetas.MASTERCARD_PLATINUM:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["MASTERCARD_PLATINUM"];
        break;
      case codigosTarjetas.MASTERCARD_BLACK:
        descripcionTipoTarjeta = deepmerge(
          nombresTarjetas,
          nombresTarjetasCampania
        )["MASTERCARD_BLACK"];
    }
    return descripcionTipoTarjeta;
  };

  //Return listado de tarjetas de credito y débito incluídas
  const tarjetasIncluidas = tipoPaquete => {
    let tarjetas = [];
    if (paquetes.tipoPaquete !== codigoPaquete.TARJETA_SUELTA) {
      switch (tipoPaquete) {
        case codigoPaquete.LIBRETON_EXPRESS:
          tarjetas = ["visa-internacional", "visa-debito-nacional"];
          break;
        case codigoPaquete.LIBRETON_PREMIUM:
          tarjetas = ["visa-master-platinum", "visa-debito-premium"];
          break;
        case codigoPaquete.LIBRETON_FULL:
          tarjetas = ["visa-master-gold", "visa-debito-nacional"];
          break;
        case codigoPaquete.LIBRETON_PREMIUM_WORLD:
          tarjetas = ["visa-master-signature", "visa-debito-premium-world"];
          break;
        case codigoPaquete.LIBRETON_PLUS_GOLD:
          tarjetas = ["visa-gold", "visa-debito-nacional"];
          break;
        default:
          tarjetas = [];
      }

      return tarjetas;
    } else {
      if (
        paquetes.tarjetas[0].tipoTarjeta == codigosTarjetas.VISA_INTERNACIONAL
      ) {
        tarjetas = ["visa-internacional", "visa-debito-nacional"];
        return tarjetas;
      } else {
        tarjetas = ["visa-gold", "visa-debito-nacional"];
        return tarjetas;
      }
    }
  };

  //Return credito total
  const totalCredito = tarjetas => {
    let totalLimite = 0;
    for (let tarjeta of tarjetas) {
      totalLimite += tarjeta.limite;
    }
    totalLimite = new Intl.NumberFormat("es-AR").format(totalLimite);
    return totalLimite;
  };

  //Return nombre tarjeta débito
  const nombreTarjetaDebito = tipoPaquete => {
    let tarjetaDebito;
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_PREMIUM:
        tarjetaDebito = "Tarjeta Visa Débito Premium";
        break;
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
        tarjetaDebito = "Tarjeta Visa Débito Premium World";
        break;
      default:
        tarjetaDebito = "Tarjeta Visa Débito";
    }
    return tarjetaDebito;
  };

  //Formateo tipo de caja de ahorro
  const tipoCajaAhorro = tipoPaquete => {
    let cajaAhorro;
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
      case codigoPaquete.LIBRETON_PREMIUM:
        cajaAhorro = "Caja de ahorro en pesos, dólares y euros";
        break;
      case codigoPaquete.LIBRETON_FULL:
        cajaAhorro = "Caja de ahorro en pesos y dólares";
        break;
      default:
        cajaAhorro = "Caja de ahorro en pesos";
    }
    return cajaAhorro;
  };

  //Formateo tipo de cuenta corriente
  const tipoCuentaCorriente = tipoPaquete => {
    let cuentaCorriente;
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
      case codigoPaquete.LIBRETON_PREMIUM:
        cuentaCorriente = `Cuenta corriente con acuerdo ${
          campania == "ofertaDigital" ? "(3)" : ""
        }`;
        break;
      case codigoPaquete.TARJETA_SUELTA:
        cuentaCorriente = "";
        break;
      default:
        cuentaCorriente = "Cuenta corriente";
    }
    return cuentaCorriente;
  };

  //formateo descripción número de tarjetas
  const numeroTarjetas = tarjetas => {
    let strNtarjetas = "";
    if (tarjetas.length > 1) {
      strNtarjetas = `entre las ${tarjetas.length} tarjetas`;
    }

    return strNtarjetas;
  };

  //Formateo costo mantenimiento
  const costoMantenimiento = tipoPaquete => {
    let _costoMantenimiento;

    // Si no tenemos precios específicos, buscamos por paquete
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_PREMIUM:
        _costoMantenimiento = "995";
        break;
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
        _costoMantenimiento = "1.338";
        break;
      case codigoPaquete.LIBRETON_PLUS_GOLD:
        _costoMantenimiento = "513";
        break;
      case codigoPaquete.LIBRETON_FULL:
        _costoMantenimiento = "751";
        break;
      default:
        _costoMantenimiento = "349";
    }
    return _costoMantenimiento;
  };

  //formateo programa LATAM Pass
  const descripcionProgramLatam = tipoPaquete => {
    let descripcionPrograma;

    if (paquetes.tipoPaquete !== codigoPaquete.TARJETA_SUELTA) {
      switch (tipoPaquete) {
        case codigoPaquete.LIBRETON_PREMIUM:
          descripcionPrograma =
            "5% de acumulación adicional de Millas LATAM Pass con los consumos y débitos automáticos de sus Tarjetas de Crédito BBVA Francés.(5)";
          break;
        case codigoPaquete.LIBRETON_PREMIUM_WORLD:
          descripcionPrograma =
            "15% de acumulación adicional de Millas LATAM Pass con los consumos y débitos automáticos de sus Tarjetas de Crédito BBVA Francés.(5)";
          break;
        case codigoPaquete.LIBRETON_FULL:
        case codigoPaquete.LIBRETON_PLUS_GOLD:
          descripcionPrograma =
            "Para acumular millas con los consumos y débitos automáticos de tus tarjetas de crédito.(4)";
          break;
        default:
          descripcionPrograma =
            "Comprando con ésta tarjeta accedes a todos los beneficios y descuentos.";
      }
      return descripcionPrograma;
    } else {
      if (paquetes.tarjetas[0].tipoTarjeta == codigosTarjetas.VISA_GOLD) {
        descripcionPrograma =
          "Comprando con ésta tarjeta accedes a todos los beneficios y descuentos.";
        return descripcionPrograma;
      } else {
        descripcionPrograma =
          "Para acumular millas con los consumos y débitos automáticos de tus tarjetas de crédito(4).";
        return descripcionPrograma;
      }
    }
  };

  const descripcionRenovacion = tipoPaquete => {
    let _descripcionRenovacion;
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_PREMIUM:
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
        _descripcionRenovacion = "Incluso después del primer año (4).";
        break;
      default:
        _descripcionRenovacion = "Incluso después del primer año (3).";
    }
    return _descripcionRenovacion;
  };

  //formateo programa label GO y LATAM Pass
  const labelGoLatam = tipoPaquete => {
    let label;
    if (paquetes.tipoPaquete !== codigoPaquete.TARJETA_SUELTA) {
      switch (tipoPaquete) {
        case codigoPaquete.LIBRETON_PREMIUM:
        case codigoPaquete.LIBRETON_PREMIUM_WORLD:
        case codigoPaquete.LIBRETON_PLUS_GOLD:
        case codigoPaquete.LIBRETON_FULL:
          label = "Te adherimos gratis al programa BBVA Francés LATAM Pass.";
          break;
        default:
          label =
            "Adherite gratis a nuestro programa Francés Go y ahorrá en tus compras.";
      }
      return label;
    } else {
      if (paquetes.tarjetas[0].tipoTarjeta == codigosTarjetas.VISA_GOLD) {
        label =
          "Adherite gratis a nuestro programa Francés Go y ahorrá en tus compras.";
        return label;
      } else {
        label = "Te adherimos gratis al programa BBVA Francés LATAM Pass.";
        return label;
      }
    }
  };

  //formateo descripción
  // const formatDescripcion = (str) => {
  //   str = str.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
  //   return str
  // }

  //Return descripcion legales por paquetes
  const descripcionLegal = tipoPaquete => {
    let _descripcionLegal;
    switch (tipoPaquete) {
      case codigoPaquete.LIBRETON_EXPRESS:
        _descripcionLegal =
          "(1) Oferta válida para altas efectuadas hasta el 30/06/2019. Transcurridos los primeros 12 meses comenzará a abonar la comisión de mantenimiento de paquete Libreton Express vigente a esa fecha. (2) La comisión mensual del paquete Libreton Express desde el 01/03/2019 será de $ 349 + iva. (3) La comisión de renovación y de mantenimiento mensual estarán bonificadas en la tarjeta de crédito vinculada al paquete mientras este último esté abierto. (4) DESCARGÁ LA APLICACIÓN EN WWW.FRANCESGO.COM.AR Y/O EN TIENDAS DE APLICACIONES DISPONIBLES EN TELÉFONOS Y/O DISPOSITIVOS CON CONEXIÓN A INTERNET Y SISTEMA IOS Y ANDROID. REGISTRATE Y COMENZÁ A RECIBIR LAS ALERTAS Y DESCUENTOS EN EL CELULAR REGISTRADO. CONSULTE TÉRMINOS Y CONDICIONES EN WWW. FRANCESGO.COM.AR";
        break;
      case codigoPaquete.LIBRETON_FULL:
        _descripcionLegal =
          "(1) Oferta válida para altas efectuadas hasta el 30/06/2019. Transcurridos los primeros 12 meses comenzará a abonar la comisión de mantenimiento de paquete Libreton Full vigente a esa fecha. (2) La comisión mensual del paquete Libreton Full desde el 01/03/2019 será de $ 751 + iva. (3) La comisión de renovación y de mantenimiento mensual estarán bonificadas en la tarjeta de crédito vinculada al paquete mientras este último esté abierto. (4) Acumulación con los consumos de Tarjeta de Crédito adherida al programa BBVA Francés LATAM Pass: por cada u$s1 o su equivalente en pesos argentinos la acumulación es de 1 milla LATAM Pass. El tipo de cambio a utilizar será el tipo de cambio vendedor informado por el banco el día de cierre de cada liquidación de tarjeta. La comisión de adhesión al programa se encuentra bonificada hasta la fecha de finalización de la presente promoción. La comisión de mantenimiento anual del programa es de $1.014 + iva y se encuentra bonificada para las Tarjetas de Crédito que se encuentren vinculadas al paquete Libreton Full.";
        break;
      case codigoPaquete.LIBRETON_PLUS_GOLD:
        _descripcionLegal =
          "(1) Oferta válida para altas efectuadas hasta el 30/06/2019. Transcurridos los primeros 12 meses comenzará a abonar la comisión de mantenimiento de paquete Libreton Plus Gold vigente a esa fecha. (2) La comisión mensual del paquete Libreton Plus Gold desde el 01/03/2019 será de $ 513 + iva. (3) La comisión de renovación y de mantenimiento mensual estarán bonificadas en la tarjeta de crédito vinculada al paquete mientras este último esté abierto. (4) Acumulación con los consumos de Tarjeta de Crédito adherida al programa BBVA Francés LATAM Pass: por cada u$s1 o su equivalente en pesos argentinos la acumulación es de 1 milla LATAM Pass. El tipo de cambio a utilizar será el tipo de cambio vendedor informado por el banco el día de cierre de cada liquidación de tarjeta. La comisión de adhesión al programa se encuentra bonificada hasta la fecha de finalización de la presente promoción. La comisión de mantenimiento anual del programa es de $1.014+iva y se encuentra bonificada para las Tarjetas de Crédito que se encuentren vinculadas al paquete Libreton Plus Gold.";
        break;
      case codigoPaquete.LIBRETON_PREMIUM:
        _descripcionLegal =
          "(1) Oferta válida para altas efectuadas hasta el 30/06/2019. Transcurridos los primeros 12 meses comenzará a abonar la comisión de mantenimiento de paquete Premium vigente a esa fecha. (2) La comisión mensual del paquete Premium desde el 01/03/2019 será de $ 995 + iva. (3) Las tasas de interés a aplicar son las vigentes al momento de su utilización y son publicadas en pizarra en nuestras sucursales. (4) La comisión de renovación y de mantenimiento mensual estarán bonificadas en la tarjeta de crédito vinculada al paquete mientras este último esté abierto. (5) Acumulación con los consumos de Tarjeta de Crédito adherida al programa BBVA Francés LATAM Pass: por cada u$s1 o su equivalente en pesos argentinos la acumulación es de 1 milla LATAM Pass. El tipo de cambio a utilizar será el tipo de cambio vendedor informado por el banco el día de cierre de cada liquidación de tarjeta. La comisión de adhesión al programa se encuentra bonificada hasta la fecha de finalización de la presente promoción. La comisión de mantenimiento anual del programa es de $1.014+iva y se encuentra bonificada para las tarjetas de crédito que se encuentren vinculadas al paquete Premium.";
        break;
      case codigoPaquete.LIBRETON_PREMIUM_WORLD:
        _descripcionLegal =
          "(1) Oferta válida para altas efectuadas hasta 30/06/2019. Transcurridos los primeros 12 meses comenzará a abonar la comisión de mantenimiento de paquete Premium World vigente a esa fecha. (2) La comisión mensual del paquete Premium World desde el 01/03/2019 será de $ 1338 + iva. (3) Las tasas de interés a aplicar son las vigentes al momento de su utilización y son publicadas en pizarra en nuestras sucursales. (4) Las tasas de interés a aplicar son las vigentes al momento de su utilización y son publicadas en pizarra en nuestras sucursales. (5) Acumulación con los consumos de Tarjeta de Crédito adherida al programa BBVA Francés LATAM Pass: por cada u$s1 o su equivalente en pesos argentinos la acumulación es de 1 milla LATAM Pass. El tipo de cambio a utilizar será el tipo de cambio vendedor informado por el banco el día de cierre de cada liquidación de tarjeta. La comisión de adhesión al programa se encuentra bonificada hasta la fecha de finalización de la presente promoción. La comisión de mantenimiento anual del programa es de $1.014+iva y se encuentra bonificada para las tarjetas de crédito que se encuentren vinculadas al paquete Premium World.";
        break;
      default:
        _descripcionLegal =
          "El titular de los datos reconoce que los datos aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública y cuyo destinatario y titular es el BBVA Banco Francés S.A. El titular de los datos presta su consentimiento expreso al Banco para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o concierte en el futuro (en adelante y en conjunto 'la información') puede ser transferida y cedida aún en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles de clientes, con fines comerciales a efecto de adoptar los productos a sus necesidades o características específicas , así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el Banco, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del Banco o de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros c) Para cualesquier otra finalidad no incompatibles con las especificadas anteriormente. Cuando así lo disponga el titular de datos tendrá el derecho de acceder a la información y solicitar su rectificación, actualización o supresión de la base de archivo. El Banco informa al titular que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan. En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras ('Foreign Account Tax Compliance Act' - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso.El titular de los datos personales tiene el derecho de acceso a los mismos en forma gratuita en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley 25326. La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley N°25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales. Sistemas de Biometría: En caso de que el Banco defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el titular de datos autoriza al Banco a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos, con intenciones publicitarias y/o con los fines que el Banco determine. Sistemas de información crediticia: Ante la solicitud de cualquier producto, el Banco puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del titular de datos.El titular de datos acepta que estará sujeto a la clasificación e inclusión en la 'Central de deudores del sistema financiero', de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del Banco informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus clientes. No será responsabilidad del Banco la utilización de la información del titular de datos por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.";
    }
    return _descripcionLegal;
  };

  let infoPaquete = {
    incluye: {
      titulo: "¿Qué incluye esta oferta?",
      items: [
        {
          label: `Tarjeta de crédito ${descripcionTarjetasIncluidas(
            paquetes.tarjetas
          )}`,
          description: `Con un límite de compra de $ ${totalCredito(
            paquetes.tarjetas
          )} ${numeroTarjetas(paquetes.tarjetas)}`
        },
        {
          label: `${nombreTarjetaDebito(paquetes.tipoPaquete)}`,
          description: ""
        },
        {
          label: `${tipoCajaAhorro(paquetes.tipoPaquete)}`,
          description: ""
        },
        {
          label: `${tipoCuentaCorriente(paquetes.tipoPaquete)}`,
          description: ""
        }
      ],
      tarjetas: tarjetasIncluidas(paquetes.tipoPaquete)
    },
    beneficios: {
      titulo: "Y te damos éstos beneficios:",
      items: [
        {
          label: "El mantenimiento será bonificado por un año.",
          description: "Luego del año se cobrará por mes la comisión vigente."
        },
        {
          label:
            "Por estar en el paquete, no se cobra la comisión por renovación anual ni el mantenimiento mensual de las tarjetas de crédito.",
          description: `${descripcionRenovacion(paquetes.tipoPaquete)}`
        },
        {
          label: `${labelGoLatam(paquetes.tipoPaquete)}`,
          description: `${descripcionProgramLatam(paquetes.tipoPaquete)}`
        }
      ]
    },
    caracteristicas: {
      tipoPaquete: paquetes.tipoPaquete,
      limite: `${totalCredito(paquetes.tarjetas)}`,
      limiteDescripcion: `${numeroTarjetas(paquetes.tarjetas)}`,
      nTarjetas: paquetes.tarjetas.length,
      tiempo: `1 año`,
      tiempoDescripcion: `mantenimiento<br> bonificado (1)`,
      mantenimiento: `${costoMantenimiento(paquetes.tipoPaquete)}`,
      mantenimientoDescripcion: `mantenimiento<br> mensual (2)`,
      mantenimientoBonificado: true,
      beneficioExtra: "",
      beneficioExtraDescripcion: "",
      tarjetas: paquetes.tarjetas,
      tarjetasDescripcion: paquetes.tarjetas.map(tarjeta =>
        descripCodeTarjeta(tarjeta.tipoTarjeta)
      )
    },
    disclaimer: "",
    descripcionLegales: `${descripcionLegal(
      paquetes.tipoPaquete
    )} LOS ACCIONISTAS DE BBVA FRANCÉS S.A. LIMITAN SU RESPONSABILIDAD A LA INTEGRACIÓN DE LAS ACCIONES SUSCRIPTAS A LA LEY 19.550 Y LEY 25.738. CUIT 30-50000319-3. AV. CÓRDOBA 111 PISO 31, CABA - CP 1054. LA POLÍTICA DE ENVÍO DE E-MAILS DE BBVA BANCO FRANCÉS S.A. NO INCLUYE LA SOLICITUD DE NINGÚN TIPO DE INFORMACIÓN CONFIDENCIAL (COMO POR EJEMPLO: CLAVES PERSONALES, N° DE CUENTAS, N° DE TARJETAS DE CRÉDITO Y/O DÉBITO, ETC.), POR LO TANTO LE SUGERIMOS NO ENVIAR DICHA INFORMACIÓN VÍA E-MAIL NI TAMPOCO INGRESARLA EN NINGÚN SITIO AL QUE USTED PUEDA ACCEDER DESDE UN LINK DISPONIBLE DENTRO DE UN E-MAIL EXCEPTO QUE SEA BAJO EL DOMINIO WW.BBVAFRANCES.COM.AR.  NO RESPONDA ESTE E-MAIL. EL TITULAR PODRÁ EN CUALQUIER MOMENTO SOLICITAR EL RETIRO O BLOQUEO DE SU NOMBRE DE LOS BANCOS DE DATOS A LOS QUE SE REFIERE EL PRESENTE ARTÍCULO. ARTÍCULO 27 DEL ANEXO I DEL DECRETO Nº 1558/01: EN TODA COMUNICACIÓN CON FINES DE PUBLICIDAD QUE SE REALICE POR CORREO, TELÉFONO, CORREO ELECTRÓNICO, INTERNET U OTRO MEDIO A DISTANCIA A CONOCER, SE DEBERÁ INDICAR, EN FORMA EXPRESA Y DESTACADA, LA POSIBILIDAD DEL TITULAR DEL DATO DE SOLICITAR EL RETIRO O BLOQUEO, TOTAL O PARCIAL, DE SU NOMBRE DE LA BASE DE DATOS. A PEDIDO DEL INTERESADO, SE DEBERÁ INFORMAR EL NOMBRE DEL RESPONSABLE O USUARIO DEL BANCO DE DATOS QUE PROVEYÓ LA INFORMACIÓN.`,
    detalleSolicitud: [
      `Tarjeta de crédito ${descripcionTarjetasIncluidas(paquetes.tarjetas)}`,
      `${nombreTarjetaDebito(paquetes.tipoPaquete)}`,
      `${tipoCajaAhorro(paquetes.tipoPaquete)}`,
      `${tipoCuentaCorriente(paquetes.tipoPaquete)}`,
      `Límite de compra de $ ${totalCredito(
        paquetes.tarjetas
      )} ${numeroTarjetas(paquetes.tarjetas)}`,
      "El mantenimiento será bonificado por un año."
    ]
  };

  // Mergear con opciones exclusivas de la campaña
  // Los arrays serán completamente reemplazados en lugar de concatenados
  const overwriteMerge = (_, sourceArray) => sourceArray;
  return deepmerge(infoPaquete, infoCampania(paquetes, infoPaquete), {
    arrayMerge: overwriteMerge
  });
};
